import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const findUser = (reg_code, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('employee-management/employee/users/reg/' + reg_code, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const myCircle = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('my-circle', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
